<template>
  <div
    class="vx-card training-item-card"
    :class="isPortrait ? 'layout-portrait' : 'layout-landscape'"
  >

    <div slot="no-body" class="image-wrapper">
      <!-- Add below event to img to select course by click on image-->
      <!--@click ="$emit('selected')"-->
      <img
        class="course-image"
        :src="item.imageUrlPortrait"
        :alt="item.title"

      />
      <div class="category-tag" :title="item.GBCharacteristic">
        {{ item.GBCharacteristic }}
      </div>
      <template v-if="isPortrait && !isTestItem">
        <div class="learning-formats">
<!--          <ul class="learning-format-list ml-3 sm:ml-6">-->
<!--            <li v-for="(formatType, idx) in item.category" :key="idx">-->
<!--              <vx-tooltip :text="formatType" title="" position="bottom">-->
<!--               <div class="format-icon">-->
<!--                  <img :src="$options.learningFormatIcons[formatType]" />-->
<!--                </div>-->
<!--              </vx-tooltip>-->
<!--            </li>-->
<!--          </ul>-->
        </div>
      </template>
    </div>
    <div class="training-item-body">
      <h5 class="mb-2 font-bold">
        <a class="text-content" :href="isTestItem ? item.testUrl : item.url" target="_blank">
          <span :title="item.title" >{{ item.title }}</span>
        </a>
      </h5>
      <p class="text-base text-content">
        {{ item.description }}
      </p>
      <div class="launch-btn">
        <a
          style="color:#3089f0"
          class="font-bold mr-1"
          @click.stop
          :href="isTestItem ? item.testUrl : item.url"
          target="_blank"
          >{{ isTestItem ? "Launch Test" : "Launch Course" }}</a
        >
        <arrow-right-icon size="1x" style="color:#3089f0"></arrow-right-icon>
      </div>
    </div>
  </div>
</template>
<script>
import { learningFormatIcons } from "@/assets/data/alex";
import { ArrowRightIcon } from "vue-feather-icons";
export default {
  name: "LibraryItemCard",
  components: {
    ArrowRightIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    layout: {
      type: String,
      default: "portrait",
      required: false,
    },
    isTestItem: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  learningFormatIcons,
  computed: {
    isPortrait() {
      return this.layout === "portrait";
    },
  },
};
</script>
<style scoped>
.training-item-card {
  overflow: hidden;
}
.training-item-body h5 a{
  color: #231d4f;
  -webkit-line-clamp: 2;
}
.training-item-body p {
  color: #848199;
  -webkit-line-clamp: 4;
}
.training-item-body {
  padding: 1.5rem;
  height: 190px;
  position: relative;
}
.training-item-body .text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.category-tag {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  color: #fff;
  bottom: 5px;
  font-size: 14px;
  padding: 2px 4.5px;
  left: 5px;
  /*display: flex; */
  /* align-items: center; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}
.image-wrapper .course-image {
  position: absolute;
  width: 100%;
}
.image-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}

.layout-portrait .image-wrapper {
  height: 360px;
}
.layout-landscape {
  display: grid;
  grid-template-columns: auto auto;
}
.layout-landscape .image-wrapper {
  height: 200px;
  width: 230px;
}

.learning-formats {
  position: absolute;
  bottom: 5px;
  right: 10px;
}
.learning-format-list {
  display: flex;
}
.learning-format-list li:hover {
  transform: translate(0px, -4px);
  z-index: 10;
}

.format-icon {
  background-color: rgba(0, 0, 0, 1) !important;
  border: 2px solid white;
  margin-right: -8px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
}
.format-icon img {
  width: 18px;
  height: 18px;
  z-index: inherit;
}
.launch-btn {
  position: absolute;
  display: flex;
  align-items: center;
  right: 15px;
  bottom: 15px;
  text-decoration: underline;
}
</style>
